import React, { useState } from "react";
import { motion } from "framer-motion";
import { Mail, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function Access() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Enter a valid email.");
    setLoading(true);
    try {
      await api.post("/auth/request-magic-link", { email });
      setSent(true);
    } catch (e) {
      toast.error("Couldn't send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App" data-testid="access-page">
      <Nav />
      <section className="min-h-[70vh] flex items-center justify-center py-24">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-md mx-auto px-6 md:px-12 w-full"
        >
          <p className="eyebrow mb-6">Already bought</p>
          <h1 className="h-display text-4xl md:text-5xl mb-4">Open your toolkit.</h1>
          <p className="text-prose mb-10">
            Enter the email you used at checkout. We'll send a fresh access link — no password to remember.
          </p>

          {sent ? (
            <div className="card-soft p-8 text-center" data-testid="access-sent">
              <Mail className="mx-auto mb-4" size={28} style={{ color: "var(--mek-accent)" }} />
              <p className="font-serif text-2xl mb-2">Check your inbox.</p>
              <p className="text-prose text-sm">
                If <span style={{ color: "var(--mek-text)" }}>{email}</span> has a kit on file, your access link is on its way. It can take a minute.
              </p>
              <button onClick={() => setSent(false)} className="btn-secondary mt-6">
                Use a different email
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="card-soft p-8" data-testid="access-form">
              <label className="eyebrow block mb-2">Email</label>
              <input
                type="email"
                className="input-line mb-6"
                placeholder="you@team.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="access-email-input"
              />
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="access-submit">
                {loading ? "Sending…" : "Send my access link"}
                {!loading && <ArrowRight size={16} />}
              </button>
            </form>
          )}
        </motion.div>
      </section>
      <Footer />
    </div>
  );
}
